  <!-- section begin -->
  <section
    id="subheader"
    class="text-light"
    data-bgimage="url(assets/images/background/10.jpg)"
    data-stellar-background-ratio=".2"
    style="background: url(assets/images/background/16.jpg) 0% 0px / cover; "
  >
    <div class="overlay-bg t50">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Dashboard</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->
  <section id="section-side" class="side-bg no-padding" data-bgcolor="#f9f9f9">
    <div class="container">


      <div class="row">
        <div class="col-md-8">
          <h2>Personal Details </h2>
            <ul>
              <li>Name : {{this.dash_name}}</li>
              <li>Gender : {{this.dash_gender}}</li>
              <li>Date Of Birth : {{this.dash_dob}}</li>
              <li>Father's Name : {{this.dash_fathername}}</li>
              <li>Mobile Number : {{this.dash_mobno}}</li>
              <li>Email Address : {{this.dash_email}}</li>
              <li>Marital Status : {{this.dash_maritalstatus}}</li>
              <li>Category : {{this.dash_category}}</li>
              <li>DIVYANG : {{this.dash_divyang}}</li>
              <li>Nationality : {{this.dash_nationality}}</li>
            </ul>
        </div>
        <div class="col-md-4">
          <h2></h2>
          <img src="http://localhost:5001/{{this.dash_image}}" style="width: 100px;">

          <button (click)="edit()">Edit</button>
        </div>
        <div class="col-md-6">
          <h2>Permanent Address </h2>
            <ul>
              <li>Door Number : {{this.dash_doorno}}</li>
              <li>Street Name : {{this.dash_streetname}}</li>
              <li>Area : {{this.dash_area}}</li>
              <li>Village / Town / City : {{this.dash_vtc}}</li>
              <li>Pincode : {{this.dash_pincode}}</li>
              <li>State : {{this.dash_state}}</li>
              <li>District : {{this.dash_district}}</li>
            </ul>
        </div>
        <div class="col-md-6">
          <h2>Communication Address </h2>
            <ul>
              <li>Door Number : {{this.dash_c_doorno}}</li>
              <li>Street Name : {{this.dash_c_streetname}}</li>
              <li>Area : {{this.dash_c_area}}</li>
              <li>Village / Town / City : {{this.dash_c_vtc}}</li>
              <li>Pincode : {{this.dash_c_pincode}}</li>
              <li>State : {{this.dash_c_state}}</li>
              <li>District : {{this.dash_c_district}}</li>
            </ul>
        </div>
        <div class="col-md-12">
          <h2>Education Qualification</h2>

          <table style="border: 1px solid;">
            <thead style="border: 1px solid;">
              <tr>
                <th>name of pass</th>
                <th>Year Of pass</th>
                <th>board / university </th>
                <th>Sub Studied</th>
                <th>Marks</th>
              </tr>
            </thead>
            <tbody>
                <tr *ngFor="let i of dash_edu_table">
                  <td>{{i.nameofpass}}</td>
                  <td>{{i.yearofpass}}</td>
                  <td>{{i.board_university}}</td>
                  <td>{{i.substudied}}</td>
                  <td>{{i.marks}}</td>
                </tr>
            </tbody>
          </table>
        </div>

        <div class="col-md-12">
          <h2>Professional Qualification</h2>

          <table style="border: 1px solid;">
            <thead style="border: 1px solid;">
              <tr>
                <th>name of pass</th>
                <th> detail of course </th>
                <th>Year Of pass</th>
                <th>board / university </th>
                <th>Sub Studied</th>
                <th>Marks</th>
              </tr>
            </thead>
            <tbody>
                <tr *ngFor="let i of dash_prof_table">
                  <td>{{i.nameofpass}}</td>
                  <td>{{i.detailofcourse}}</td>
                  <td>{{i.yearofpass}}</td>
                  <td>{{i.board_university}}</td>
                  <td>{{i.substudied}}</td>
                  <td>{{i.marks}}</td>
                </tr>
            </tbody>
          </table>
        </div>

        <div class="col-md-12">
          <h2>Work Experience</h2>

          <table style="border: 1px solid;">
            <thead style="border: 1px solid;">
              <tr>
                <th>address of emp</th>
                <th>from date</th>
                <th>to date </th>
                <th>scale of pay</th>
                <th>service</th>
                <th>nature work</th>
              </tr>
            </thead>
            <tbody>
                <tr *ngFor="let i of dash_wrkexp_table">
                  <td>{{i.addressofemp}}</td>
                  <td>{{i.fromdate}}</td>
                  <td>{{i.todate}}</td>
                  <td>{{i.scaleofpay}}</td>
                  <td>{{i.service}}</td>
                  <td>{{i.naturework}}</td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>



</div>
  </section>


